export enum FiltersKeyEnum {
  notifications = 'notifications',
  devices = 'devices',
  users = 'users',
  folders = 'folders',
  clockIn = 'clock-in',
  schedules = 'schedules',
  orders = 'orders',
  deliveryNotes = 'delivery-notes',
  cashClosing = 'cash-closing',
  payments = 'payments',
  ebitda = 'ebitda',
  expenses = 'expenses',
  recipeCosting = 'recipe-costing',
  recipe = 'recipe',
  elaboration = 'elaboration',
  labeled = 'labeled',
  miseEnPlace = 'mise-en-place',
  tasks = 'tasks',
  imagesReviewer = 'images-reviewer',
  models = 'models',
  schedulesChecklists = 'schedules-checklists',
  schedulesAppccs = 'schedules-appccs',
  wastage = 'wastage',
  operations = 'operations',
  operationInventory = 'operation-inventory',
  transfers = 'transfers',
  stocks = 'stocks',
  requests = 'requests',
  dashboard = 'dashboard',
  productPurchaseReport = 'product-purchase-report',
  providerPurchaseReport = 'provider-purchase-report',
  checklistsReport = 'checklists-report',
  auditReport = 'audit-report',
  appccReport = 'appcc-report',
  clockInReport = 'clock-in-report',
  communication = 'communication',
  widgets = 'widgets',
  inventoryStock = 'inventory-stock',
  events = 'events',
  documentsReview = 'documents-review',
}
